import { render, staticRenderFns } from "./OtherIncomePaymentReceiptForm.vue?vue&type=template&id=d5c245d4"
import script from "./OtherIncomePaymentReceiptForm.vue?vue&type=script&lang=js"
export * from "./OtherIncomePaymentReceiptForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports